import upsLogo from '@/assets/images/upslogo.png';

export type ShippingStatus = 'Pending' | 'Shipped' | 'Delivered' | 'Cancelled' | 'Action Required' | 'Awaiting Pickup' | 'Label Created';

export interface OrderItem {
  productName: string;
  sku: string;
  quantity: number;
  price: number;
}

export interface Order {
  key: number;
  processing: boolean;
  name: string;
  status: ShippingStatus;
  orderDate: string;
  orderNumber: string;
  tracking: string;
  shippingMethod: string;
  shippingLogo: string;
  country: string;
  items: OrderItem[];
  totalAmount?: number;
}

export const initialOrders: Order[] = [
  {
    key: 1,
    processing: true,
    name: 'Francis Lokossou',
    status: 'Pending',
    orderDate: '06/09/2019',
    orderNumber: '#ABCD-0780967',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇺🇸',
    items: [
      { productName: 'Wireless Headphones', sku: 'WH-1000XM4', quantity: 1, price: 349.99 },
      { productName: 'USB-C Cable', sku: 'USBC-001', quantity: 2, price: 12.99 },
    ],
    totalAmount: 375.97,
  },
  {
    key: 2,
    processing: true,
    name: 'Narcisse Adeoti',
    status: 'Pending',
    orderDate: '01/11/2019',
    orderNumber: '#ABCD-0780968',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇧🇩',
    items: [
      { productName: 'Bluetooth Speaker', sku: 'BT-SPK-500', quantity: 1, price: 129.99 },
    ],
    totalAmount: 129.99,
  },
  {
    key: 3,
    processing: true,
    name: 'John Smith',
    status: 'Label Created',
    orderDate: '14/06/2020',
    orderNumber: '#ABCD-0780969',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇨🇦',
    items: [
      { productName: 'Gaming Mouse', sku: 'GM-PRO-X', quantity: 1, price: 79.99 },
      { productName: 'Mouse Pad XL', sku: 'MP-XL-001', quantity: 1, price: 29.99 },
    ],
    totalAmount: 109.98,
  },
  {
    key: 4,
    processing: true,
    name: 'Maria Garcia',
    status: 'Label Created',
    orderDate: '15/06/2020',
    orderNumber: '#ABCD-0780970',
    tracking: 'TRK111222333',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇺🇸',
    items: [
      { productName: 'Mechanical Keyboard', sku: 'KB-MEC-RGB', quantity: 1, price: 149.99 },
    ],
    totalAmount: 149.99,
  },
  {
    key: 5,
    processing: true,
    name: 'Ahmed Hassan',
    status: 'Shipped',
    orderDate: '14/06/2020',
    orderNumber: '#ABCD-0780971',
    tracking: 'TRK789012345',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇦🇷',
    items: [
      { productName: 'Webcam HD Pro', sku: 'WC-HD-PRO', quantity: 1, price: 99.99 },
      { productName: 'Microphone Stand', sku: 'MIC-STAND-01', quantity: 1, price: 34.99 },
    ],
    totalAmount: 134.98,
  },
  {
    key: 6,
    processing: true,
    name: 'Chen Wei',
    status: 'Delivered',
    orderDate: '03/07/2019',
    orderNumber: '#ABCD-0780972',
    tracking: 'TRK123456789',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇺🇸',
    items: [
      { productName: 'Laptop Stand', sku: 'LP-STAND-ALU', quantity: 1, price: 59.99 },
      { productName: 'Cable Organizer', sku: 'CBL-ORG-001', quantity: 3, price: 9.99 },
    ],
    totalAmount: 89.96,
  },
  {
    key: 7,
    processing: true,
    name: 'Sophie Martin',
    status: 'Cancelled',
    orderDate: '28/03/2020',
    orderNumber: '#ABCD-0780973',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇧🇷',
    items: [
      { productName: 'Monitor 27"', sku: 'MON-27-4K', quantity: 1, price: 449.99 },
    ],
    totalAmount: 449.99,
  },
  {
    key: 8,
    processing: true,
    name: 'David Johnson',
    status: 'Cancelled',
    orderDate: '29/03/2020',
    orderNumber: '#ABCD-0780974',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇬🇧',
    items: [
      { productName: 'External SSD 1TB', sku: 'SSD-EXT-1TB', quantity: 1, price: 129.99 },
    ],
    totalAmount: 129.99,
  },
  {
    key: 9,
    processing: true,
    name: 'Elena Rodriguez',
    status: 'Action Required',
    orderDate: '07/04/2020',
    orderNumber: '#ABCD-0780975',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇳🇵',
    items: [
      { productName: 'Phone Case', sku: 'PC-IPHONE-14', quantity: 2, price: 24.99 },
      { productName: 'Screen Protector', sku: 'SP-GLASS-001', quantity: 2, price: 14.99 },
    ],
    totalAmount: 79.96,
  },
  {
    key: 10,
    processing: true,
    name: 'Tom Anderson',
    status: 'Action Required',
    orderDate: '08/04/2020',
    orderNumber: '#ABCD-0780976',
    tracking: '',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇦🇺',
    items: [
      { productName: 'Smart Watch', sku: 'SW-SPORT-001', quantity: 1, price: 299.99 },
    ],
    totalAmount: 299.99,
  },
  {
    key: 11,
    processing: true,
    name: 'Lisa Brown',
    status: 'Awaiting Pickup',
    orderDate: '07/04/2020',
    orderNumber: '#ABCD-0780977',
    tracking: 'TRK444555666',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇬🇧',
    items: [
      { productName: 'Tablet 10"', sku: 'TAB-10-WIFI', quantity: 1, price: 399.99 },
      { productName: 'Tablet Case', sku: 'TC-10-BLK', quantity: 1, price: 39.99 },
    ],
    totalAmount: 439.98,
  },
  {
    key: 12,
    processing: true,
    name: 'Michael Lee',
    status: 'Awaiting Pickup',
    orderDate: '08/04/2020',
    orderNumber: '#ABCD-0780978',
    tracking: 'TRK777888999',
    shippingMethod: 'UPS',
    shippingLogo: upsLogo,
    country: '🇯🇵',
    items: [
      { productName: 'Fitness Tracker', sku: 'FT-BAND-002', quantity: 1, price: 89.99 },
    ],
    totalAmount: 89.99,
  },
];

// Helper function to get order statistics
export const getOrderStats = (orders: Order[]) => {
  const pending = orders.filter(order => order.status === 'Pending').length;
  const labelCreated = orders.filter(order => order.status === 'Label Created').length;
  const shipped = orders.filter(order => order.status === 'Shipped' || order.status === 'Delivered').length;
  const cancelled = orders.filter(order => order.status === 'Cancelled').length;
  const actionRequired = orders.filter(order => order.status === 'Action Required').length;
  const awaitingPickup = orders.filter(order => order.status === 'Awaiting Pickup').length;
  
  // Count total items across all pending orders
  const totalItems = orders
    .filter(order => order.status === 'Pending')
    .reduce((sum, order) => sum + order.items.reduce((itemSum, item) => itemSum + item.quantity, 0), 0);
  
  return {
    pending,
    labelCreated,
    shipped,
    cancelled,
    actionRequired,
    awaitingPickup,
    totalOrders: orders.length,
    totalItems,
  };
};
